import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, KeyRound } from "lucide-react";

const MSG = {
  expired: "Your Dhan token has expired.",
  before_open: "Your Dhan token expires before the market opens.",
  during_session: "Your Dhan token expires during the trading session.",
  soon: "Your Dhan token expires soon.",
};

const slotKey = (a, r) => `orb-token-${a.expires_at}-${r.slot}`;

const notifiedKey = (a) => `orb-token-reminder-${a.session_date}`;

export const TokenReminder = ({ alert, onRenew }) => {
  const [perm, setPerm] = useState(typeof Notification !== "undefined" ? Notification.permission : "unsupported");

  useEffect(() => {
    if (!alert || perm !== "granted" || alert.minutes_to_open > 45 || alert.minutes_to_open < 0) return;
    if (localStorage.getItem(notifiedKey(alert))) return;
    new Notification("Nifty ORB Desk: renew Dhan token", { body: `${MSG[alert.level]} Expires ${alert.expires_at_ist} IST. Paste a new token before 9:15.` });
    localStorage.setItem(notifiedKey(alert), "1");
  }, [alert, perm]);

  useEffect(() => {
    if (!alert?.reminders || alert.level === "expired") return undefined;
    const check = () => {
      const now = Date.now();
      for (const r of alert.reminders) {
        if (now < Date.parse(r.at) || now > Date.parse(alert.expires_at) || localStorage.getItem(slotKey(alert, r))) continue;
        localStorage.setItem(slotKey(alert, r), "1");
        const body = `${MSG[alert.level]} Expires ${alert.expires_at_ist} IST. Open Settings and paste a fresh token.`;
        toast.warning(`Renew your Dhan token · ${r.label}`, { description: body, duration: 30000 });
        if (perm === "granted") new Notification("Nifty ORB Desk: renew Dhan token", { body, tag: slotKey(alert, r) });
      }
    };
    check();
    const id = setInterval(check, 30000);
    return () => clearInterval(id);
  }, [alert, perm]);

  if (!alert) return null;
  const red = !["during_session", "soon"].includes(alert.level) || alert.pre_open;
  const next = (alert.reminders || []).filter((r) => Date.parse(r.at) > Date.now());
  return (
    <div data-testid="banner-token-reminder" className={`flex flex-wrap items-center gap-2 border-t px-3 py-2 text-xs sm:px-4 ${red ? "border-red-500/30 bg-red-500/10 text-red-300" : "border-amber-500/20 bg-amber-500/10 text-amber-300"}`}>
      <KeyRound size={14} />
      <span>
        <b>{MSG[alert.level]}</b> Expires <span className="num">{alert.expires_at_ist}</span> IST{alert.level === "soon" ? "." : ","} {alert.level === "soon" ? "" : alert.level === "during_session" ? `before the ${alert.session_date} session closes.` : `before the ${alert.session_date} session opens.`}
        {alert.level !== "expired" && " Paste a fresh token before 9:15 IST so live and dry-run trading aren't interrupted."}
        {alert.pre_open && alert.minutes_to_open >= 0 && <span className="num"> Market opens in {alert.minutes_to_open} min.</span>}
        {next.length > 0 && <span className="num text-[11px] opacity-80" data-testid="token-reminder-schedule"> Reminders: {next.map((r) => `${r.label} ${new Date(r.at).toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit" })}`).join(" · ")}{perm !== "granted" ? " (in-app only)" : ""}.</span>}
      </span>
      <span className="ml-auto flex items-center gap-3">
        {perm === "default" && (
          <button data-testid="button-enable-reminders" onClick={() => Notification.requestPermission().then(setPerm)} className="flex items-center gap-1 underline underline-offset-2">
            <BellRing size={12} /> Desktop reminder
          </button>
        )}
        <button data-testid="button-renew-token" onClick={onRenew} className="font-semibold underline underline-offset-2">Renew token</button>
      </span>
    </div>
  );
};
